/*eslint-disable*/ export const messages = {
    'Add "{inputValue}"': ["Ajouter « ", ["inputValue"], " »"],
    "All items have been removed.": "Tous les éléments ont été retirés.",
    "Clear selection": "Effacer la sélection",
    "No results found.": "Aucun résultat trouvé.",
    "Select All": "Sélectionner tout",
    "Selected Items": "Sélectionner des éléments",
    "Toggle menu": "Activer/Désactiver le menu",
    "listbox contents": "contenu de la zone de liste",
    "{itemAsString} has been removed.": [["itemAsString"], " a été retiré."],
    "{itemAsString} has been selected.": [["itemAsString"], " a été sélectionné."],
    "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.":
        [
            ["resultCount", "plural", { one: ["#", " résultat est"], other: ["#", " résultats sont"] }],
            " disponible(s), utilisez les touches fléchées haut et bas pour naviguer. Veuillez appuyer sur la touche Enter pour sélectionner.",
        ],
    "{selectedValue} selected": [["selectedValue"], " sélectionné"],
};
